<template>
    <div class="desk" :class="{'open-menu':IsShowSubMenus,'no-menu':!IsShowLeftMenu,'no-header':!IsShowHeader}">
        <div class="header clearfix" v-if="IsShowHeader">
            <a class="logo" href="/">数字红会综合服务平台</a>
            <a class="logo-index" href="https://www.zjredcross.org/#/index" target="_blank">站点首页</a>
            <ul class="ctrl">
                <li v-if="false">
                    <a @click="showAdminInfo=true">
                        <i class="fa fa-phone-square"></i>
                        联系管理员
                    </a>
                </li>
                <li v-for="(item,index) in QuickMenus" :key="item.id" :index="index" @click="quickMenuItemClick(item)">
                    <a>
                        <i :class="item.IconCss"></i>
                        {{item.MenuName}}
                    </a>
                </li>
                <li class="hoverdown" v-if="EnableI18n">
                    <a>
                        {{CurrentLocale}}
                        <i class="fa fa-angle-down"></i>
                    </a>
                    <div class="hoverdown-menu">
                        <div class="hoverdown-menu-content">
                            <a @click="toggleLocales(item.k)" v-for="(item,index) in Locales" :key="index"
                               :index="index">{{item.v}}</a>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <!--header-->
        <div class="menu"  v-if="IsShowLeftMenu">
            <ul>
                <template v-for="(item, index) in Menus" :index="index">
                    <li @click="menuItemClick(item)" :key="item.id" :class="{active:CurrentActiveMainMenuID==item.id}">
                        <!-- <i :class="item.icon"></i>
                        <span>{{item.text}}</span> -->
                        <!-- <font v-if="TipsQty.length>index&&TipsQty[index]!='0'">{{TipsQty[index]}}</font> -->
                        <div class="menu-text">
                            <i :class="item.icon" class="text-icon"></i>
                            <div class="text-desc">{{item.text}}</div>
                        </div>

                        <!--                        <spen style="color: #2b542c;size: 40px">{{item.text}}</spen>-->
                    </li>

                </template>
            </ul>
            <div class="menu-sub">
                <template v-for="(item,index) in SubMenus" :index="index">
                    <dl @click.stop="subMenuItemClick(item)" :key="item.id"
                        :class="{'menu-sub-list':item.children&&item.children.length>0,'active':item.id===CurrentSpreadMenuID}">
                        <dt>
                            <el-badge :value="worknum" class="item" v-if="item.text === '待办工单' && worknum != 0">
                                <a :class="{'active':CurrentActiveSubMenuID===item.id}">{{item.text}}</a>
                            </el-badge>
                            <a v-else :class="{'active':CurrentActiveSubMenuID===item.id}">{{item.text}}</a>
                        </dt>
                        <dd v-if="item.children&&item.children.length>0">
                            <a @click.stop="subMenuItemClick(item2)"
                               :class="{'active':CurrentActiveSubMenuID===item2.id}"
                               v-for="(item2,index2) in item.children" :key="item2.id"
                               :index="index2">{{item2.text}}</a>
                        </dd>
                    </dl>
                </template>
            </div>
            <menu-user :show-user-center-link="showUserCenterLink"></menu-user>
        </div>
        <!--menu-->
        <div class="content">
            <router-view></router-view>
        </div>
        <!--content-->
        <admin-info v-if="showAdminInfo" @pickerCallBack="showAdminInfo = false"></admin-info>
    </div>
</template>

<script>
    import {mapGetters, mapMutations} from "vuex";
    import adminInfo from "@/shared/calladmin.vue";
    import menuUser from "@/shared/menu_user.vue";
    import api from "@/modules/zjrc/api";

    export default {
        name: "of-layout",
        components: {
            adminInfo, menuUser
        },
        data() {
            return {
                showAdminInfo: false,
                Locales: [{k: "zh-cn", v: "中文"}, {k: "en", v: "English"}],
                CurrentBreadcrumb: [],
                EditPassWordVisible: false,
                CurrentActiveMainMenuID: "", //当前活动一级菜单Id
                CurrentSpreadMenuID: "", //当前展开的MenuId
                CurrentActiveSubMenuID: "", //当前活动的子菜单Id
                TipsQty: [],
                isCollapse:true,
                worknum: 0,
                searchModel: {
                    searchKey: "",
                    currentPage: 1,
                    pageSize: 15,
                    IsCompleted: false,
                    procId: "",
                },
                homeUrl: process.env.VUE_APP_HOME_URL
            };
        },
        computed: {
            showUserCenterLink() {
                return this.UserMenus && this.UserMenus.length > 0;
            },
            ...mapGetters([
                "GetIsLoading",
                "GetCurrentUserInfo",
                "GetCurrentPermissions",
                "GetCurrentMenus",
                "GetCurrentConfig"
            ]),
            IsShowLeftMenu() {
                let nomenu = this.$route.query.nomenu;
                if (nomenu) {
                    return false;
                }
                return true;
            },
            IsShowHeader() {
                let noheader = this.$route.query.noheader;
                if (noheader) {
                    return false;
                }
                return true;
            },
            Menus() {
                let permissions = this.GetCurrentPermissions;
                let menuList = this.GetCurrentMenus.filter(item => {
                    let node = permissions.find(obj => {
                        return obj.ModuleKey === item.ModuleKey && obj.Operation === "read";
                    });
                    return (
                        !item.ModuleKey ||
                        (item.ModuleKey && (!node || (node && node.HasAccess)))
                    );
                });
                let menuList2 = menuList.filter(item => {
                    let childrens = menuList.filter(obj => {
                        return item.Id === obj.ParentId;
                    });
                    return (
                        item.MenuUrl || (!item.MenuUrl && childrens && childrens.length > 0)
                    );
                });
                let menuTree = this._menuListToTree(menuList2);
                return menuTree;
            },
            QuickMenus() {
                let permissions = this.GetCurrentPermissions;
                let menuList = this.GetCurrentMenus.filter(item => {
                    let node = permissions.find(obj => {
                        return obj.ModuleKey === item.ModuleKey && obj.Operation === "read";
                    });
                    return (
                        (!item.ModuleKey ||
                            (item.ModuleKey && (!node || (node && node.HasAccess)))) &&
                        item.MenuType === 1
                    );
                });

                return menuList;
            },
            UserMenus() {
                let permissions = this.GetCurrentPermissions;
                let menuList = this.GetCurrentMenus.filter(item => {
                    let node = permissions.find(obj => {
                        return obj.ModuleKey === item.ModuleKey && obj.Operation === "read";
                    });
                    return (
                        (!item.ModuleKey ||
                            (item.ModuleKey && (!node || (node && node.HasAccess)))) &&
                        item.MenuType === 2
                    );
                });

                return menuList;
            },
            SubMenus() {
                let menuItem = this.Menus.find(
                    item => item.id === this.CurrentActiveMainMenuID
                );
                return menuItem && menuItem.children ? menuItem.children : [];
            },
            IsShowSubMenus() {
                return this.SubMenus && this.SubMenus.length ? true : false;
            },
            CurrentLocale() {
                let o = this.Locales.find(item => item.k === this.$i18n.locale);
                return o ? o.v : "中文";
            },
            IsLoading() {
                return this.GetIsLoading;
            },
            LeftAsideWidth() {
                return this.IsCollapse ? "65px" : "240px";
            },
            HeaderMenuLeft() {
                return this.IsCollapse ? "111px" : "286px";
            },
            HeaderMenuWidth() {
                let clientWidth = document.documentElement.clientWidth;
                let leftwidth = this.IsCollapse ? 111 : 286;
                let menuwidth = clientWidth - leftwidth - 200;
                return menuwidth + "px";
            },
            LeftMenuHeight() {
                let clientHeight = document.documentElement.clientHeight;
                return clientHeight - 60 - 124 + "px";
            },
            ContentHeight() {
                let clientHeight = document.documentElement.clientHeight;
                return clientHeight - 60 + "px";
            },
            SystemTitle() {
                let title = "OF Framework";
                let currentConfig = this.GetCurrentConfig;
                if (currentConfig && currentConfig.SystemTitle) {
                    title = currentConfig.SystemTitle;
                }
                return title;
            },
            EnableI18n() {
                let r = 0;
                let currentConfig = this.GetCurrentConfig;
                if (currentConfig && currentConfig.EnableI18n) {
                    r = currentConfig.EnableI18n;
                }
                return r;
            },

        },
        mounted() {
            this._initActiveMenu();
            this.Menus.forEach(() => {
                this.TipsQty.push("0");
            });
            this.$bus.$on("setMenuItemTip", (index, val) => {
                // if (val > 99) {
                //   val = "99+";
                // }
                this.$set(this.TipsQty, index, val);
            });

            let currentUserInfo = this.GetCurrentUserInfo;
            if (currentUserInfo && currentUserInfo.HeadPicture) {
                // src = currentUserInfo.HeadPicture;
            }
            window.addEventListener('setItem',() => {
                this.worknum = localStorage.getItem('worknum')
            })
            this.getWorkNum()
        },
        methods: {
            getWorkNum(){
                let that = this;
                let params = {
                    SearchKey: that.searchModel.searchKey,
                    PageIndex: that.searchModel.currentPage,
                    PageSize: that.searchModel.pageSize,
                    UserId: that.GetCurrentUserInfo.Id,
                    IsCompleted: false,
                    ProcId:that.searchModel.procId
                };
                that.isloading = true;
                api.QueryBacklog(params).then((res) => {
                    if (res.data.Code == 0) {
                        that.worknum = res.data.Data.total;
                        this.$addStorageEvent(1,'worknum',that.worknum);
                    }
                });
            },
            ...mapMutations({
                setRedirectUrl: "UPDATE_REDIRECT_URL",
                setUsertoken: "UPDATE_USERTOKEN"
            }),
            _initActiveMenu() {
                let menuObj = this.GetCurrentMenus.find(obj => {
                    return obj.MenuUrl === this.$route.path;
                });
                if (menuObj) {
                    this.CurrentActiveSubMenuID = menuObj.Id;
                    this.CurrentSpreadMenuID = menuObj.Id;
                    this.CurrentActiveMainMenuID = menuObj.Id;
                    if (menuObj.ParentId) {
                        this.CurrentSpreadMenuID = menuObj.ParentId;
                        this.CurrentActiveMainMenuID = menuObj.ParentId;
                    }
                    let menuObj2 = this.GetCurrentMenus.find(obj => {
                        return obj.Id === menuObj.ParentId;
                    });
                    if (menuObj2 && menuObj2.ParentId) {
                        this.CurrentActiveMainMenuID = menuObj2.ParentId;
                    }
                }
            },
            _menuListToTree(data) {
                function tree(id) {
                    let arr = [];
                    data
                        .filter(item => {
                            if (id) {
                                return item.ParentId === id && !item.MenuType;
                            } else {
                                return (
                                    (item.ParentId === "" || item.ParentId === null) &&
                                    !item.MenuType
                                );
                            }
                        })
                        .forEach(item => {
                            var children = tree(item.Id);
                            // 没有子菜单或没有链接，则隐藏菜单
                            if (children.length > 0 || item.MenuUrl) {
                                arr.push({
                                    id: item.Id,
                                    text: item.MenuName,
                                    icon: item.IconCss,
                                    url: item.MenuUrl,
                                    key: item.ModuleKey,
                                    children: tree(item.Id)
                                });
                            }
                        });
                    return arr;
                }

                return tree(null);
            },
            toggleLocales(val) {
                this.$i18n.locale = val;
            },
            quickMenuItemClick(item) {
                if (item) {
                    this.goto({
                        url: item.MenuUrl
                    });
                }
            },
            menuItemClick(item) {
                if (item) {
                    if (item.children && item.children.length > 0) {
                        //有子菜单
                        if (this.CurrentActiveMainMenuID === item.id) {
                            this.CurrentActiveMainMenuID = "";
                        } else {
                            this.CurrentActiveMainMenuID = item.id;
                        }
                    } else {
                        this.CurrentActiveMainMenuID = item.id;
                        this.CurrentSpreadMenuID = "";
                        this.CurrentActiveSubMenuID = "";
                        this.goto(item);
                    }
                }
            },
            subMenuItemClick(item) {
                if (item) {
                    if (item.children && item.children.length > 0) {
                        if (this.CurrentSpreadMenuID === item.id) {
                            this.CurrentSpreadMenuID = "";
                        } else {
                            this.CurrentSpreadMenuID = item.id;
                        }
                    } else {
                        this.CurrentActiveSubMenuID = item.id;
                        this.goto(item);
                    }
                }
            },
            toggleShowSubMenu(item) {
                if (item.children && item.children.length > 0) {
                    if (this.CurrentSpreadMenuID !== item.id) {
                        this.CurrentSpreadMenuID = item.id;
                    } else if (this.CurrentSpreadMenuID) {
                        this.CurrentSpreadMenuID = "";
                    }
                } else {
                    this.goto(item);
                }
            },
            goto(item) {
                if (item.url && item.url !== "#") {
                    if (item.url.substr(0, 4) === "http") {
                        window.open(item.url);
                    } else {
                        this.$router.push(item.url);
                    }
                    this.CurrentActiveSubMenuID = item.id;
                }
            },
            logoclick() {
                this.$router.push("/");
            },
            toggle() {
                this.IsCollapse = !this.IsCollapse;
            },
            handleSelect(id) {
                this.CurrentTopMenuID = id;
            },
            onRedirect(item) {
                this.CurrentBreadcrumb = [];
                this.CurrentBreadcrumb.push(item);
            },
            _updatePassword() {
                this.EditPassWordVisible = true;
                this.formTitle = "修改密码";
                this.formData = this.GetCurrentUserInfo;
            },

        }
    };
</script>

<style scoped>
.item >>>.el-badge__content.is-fixed{
        right: 30px;
}
.logo-index {
    margin-left: 20px;
    display: block;
    float: left;
    font-size: 16px;
    /* font-weight: bold; */
    line-height: 38px;
    color: #004a86 !important;
    cursor: pointer;
}
</style>